var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.761 7.22638C12.1578 6.97431 12.4211 6.53092 12.4211 6.02604C12.4211 5.24121 11.7849 4.60498 11 4.60498C10.2152 4.60498 9.57898 5.24121 9.57898 6.02604C9.57898 6.53088 9.84224 6.97424 10.239 7.22632C10.2257 7.24429 10.2129 7.2629 10.2007 7.28214L8.31822 10.2403C7.99283 10.7517 7.27763 10.8302 6.84907 10.4016L4.89215 8.44468C4.8552 8.40773 4.81688 8.3747 4.77748 8.34543C4.8194 8.21135 4.84199 8.06874 4.84199 7.92085C4.84199 7.13602 4.20576 6.49979 3.42094 6.49979C2.63611 6.49979 1.99988 7.13602 1.99988 7.92085C1.99988 8.6654 2.57248 9.27622 3.30135 9.33695C3.30195 9.33941 3.30256 9.34187 3.30317 9.34434L5.13634 16.677C5.24177 17.0987 5.62071 17.3946 6.05542 17.3946H16.829C17.2921 17.3946 17.6874 17.0598 17.7635 16.603L18.9834 9.28354C19.5713 9.1094 20.0002 8.56519 20.0002 7.92081C20.0002 7.13598 19.364 6.49976 18.5791 6.49976C17.7943 6.49976 17.1581 7.13598 17.1581 7.92081C17.1581 8.06435 17.1794 8.20291 17.2189 8.33353L15.1509 10.4016C14.7223 10.8302 14.0071 10.7516 13.6817 10.2403L11.7992 7.28213C11.787 7.26292 11.7743 7.24433 11.761 7.22638Z",
    fill: "#FF6262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrown);
export default __webpack_public_path__ + "static/media/ic_crown.a9fc59b16067cf878802ad7a2ebc7ec3.svg";
export { ForwardRef as ReactComponent };